import { IsBoolean, IsInt, IsNotEmpty, IsOptional } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../../../../common/src/builders/error-message.builder';

export class RolloverPropertyTransferredSection84_3Result {
  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  nonShareConsideration?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  totalPaidUpCapital?: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  paidUpCapitalOfTransferredShares?: number;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isDeemedDividendApplicable: boolean;
}